import { create } from 'zustand';

const momentStore = create((set, get) => ({
  selectedItem: null,

  // Stocke l'item sélectionné
  setSelectedItem: (item) => set({ selectedItem: item }),

  // Une fonction générique à appeler depuis le popup (tu peux la changer ou l'étendre)
  // On stocke une fonction externe (ex: handleAction de FullPagePC)
  registeredHandler: null,
  registerHandler: (fn) => set({ registeredHandler: fn }),

  // Appel depuis n'importe où
  triggerHandler: () => {
    const { selectedItem, registeredHandler } = get();

    if (selectedItem && typeof registeredHandler === 'function') {
      registeredHandler(selectedItem);
    }
  },




}));

export default momentStore;
